/**
 * Apresentação do resultado de POST /v2/stock/simulate-anticipation
 * (escada δ-r1 G2). O proxy repassa a resposta da V2 CRUA (sem reshape) e o
 * shape REAL — conferido na fonte, v2 main E wip/ultrareview-corretivo,
 * `backend/app/api/v1/routes/stock.py` — é:
 *
 *   { status, opr_gross_face_value, opr_net_face_value, opr_discounted_value,
 *     opr_liquid_value, average_days_in_advance, floating_days, product_id,
 *     receivables: [{ stock_item_id, external_id, gross_face_value,
 *       net_face_value, requested_advance_value, due_date, days_advanced,
 *       discount_brl, liquid_value, monthly_rate_pct, discount_pct,
 *       fixed_discount_brl, fee_source }] }
 *
 * A chave da lista é `receivables` (NUNCA `items`) e o desconto por item é
 * `discount_brl` (NUNCA `discount_value`); valores monetários vêm como STRING
 * decimal. `average_days_in_advance` é média do prazo de CALENDÁRIO, SEM
 * floating (total_days // len) — só o `days_advanced` por item reflete os
 * dias cobrados; por isso o agregado é rotulado "Prazo médio", não "dias
 * cobrados" (escada δ-r1 M1).
 *
 * ── Vocabulário CANÔNICO da V2 (PUBLIC_ALIASES) ────────────────────────────
 * O item da lista é tipado por `StockSimulatedReceivable`
 * (v2 `backend/app/api/v1/schemas/responses.py:853`), que é
 * `AdditiveVocabularyOut`: a V2 1.x emite os DOIS nomes de cada par e a 2.0
 * remove os deprecados. Pares que esta lib lê:
 *
 *   gross_face_value        → gross_future_value
 *   requested_advance_value → requested_net_future_value
 *   liquid_value            → net_present_liquid_value
 *   discount_brl            → present_value_discount
 *
 * Leitura = `canônico ?? deprecado`, seleção por NULLISH e NUNCA por `||`: um
 * `0` canônico legítimo (deságio zero, líquido zero) não pode cair no nome
 * deprecado. `fixed_discount_brl` NÃO entra — é homônimo fora da tabela.
 */

/** Linhas do "detalhamento por item" — números prontos para formatBRL. */
export function simulationDetailRows(simResult) {
  return (simResult?.receivables || []).map((r) => ({
    id: r.stock_item_id,
    externalId: r.external_id,
    gross: parseFloat(r.gross_future_value ?? r.gross_face_value),
    advance: parseFloat(r.requested_net_future_value ?? r.requested_advance_value),
    liquid: parseFloat(r.net_present_liquid_value ?? r.liquid_value),
    discount: parseFloat(r.present_value_discount ?? r.discount_brl),
    daysAdvanced: r.days_advanced,
    feeSource: r.fee_source,
  }));
}
